import { createReducer, on } from "@ngrx/store";
import * as featureFlagsActions from "./feature-flags.actions";
import * as _ from "lodash";
import { FeatureFlagModel } from "../../models/feature-flag.model";

type FeatureFlagSlice<K extends string> = {
  initialState: boolean;
  success: boolean;
  errorCode: string;
  errorMessage: string;
} & Record<K, FeatureFlagModel | null>;

export type FeatureFlagTeleAdviceStateModel =
  FeatureFlagSlice<'teleAdvice'>;

export type FeatureFlagHillsPostAdoptionDTCStateModel =
  FeatureFlagSlice<'hillsPostAdoptionDTC'>;

export type FeatureFlagInsuranceStateModel =
  FeatureFlagSlice<'insurance'>;

const createFeatureFlagInitialState = <K extends string>(key: K) =>
({
  initialState: true,
  success: true,
  errorCode: '',
  errorMessage: '',
  [key]: null,
} as FeatureFlagSlice<K>);

export const featureFlagsInitialState: FeatureFlagTeleAdviceStateModel =
  createFeatureFlagInitialState('teleAdvice');

export const featureFlagHillsPostAdoptionDTCInitialState: FeatureFlagHillsPostAdoptionDTCStateModel =
  createFeatureFlagInitialState('hillsPostAdoptionDTC');

export const featureFlagInsuranceInitialState: FeatureFlagInsuranceStateModel =
  createFeatureFlagInitialState('insurance');

export const featureFlagTeleAdviceReducer = createReducer(
  featureFlagsInitialState,
  on(featureFlagsActions.loadFeatureFlagTeleAdvice, (state) => state),
  on(featureFlagsActions.setFeatureFlagTeleAdvice, (state, { featureFlag }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    teleAdvice: featureFlag
  })),
  on(featureFlagsActions.getFeatureFlagTeleAdviceError, (state, { errorCode, errorMessage }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: false,
    errorCode,
    errorMessage
  })),
  on(featureFlagsActions.resetFeatureFlagTeleAdvice, () => ({
    ..._.cloneDeep(featureFlagsInitialState),
  }))
);

export const featureFlagHillsPostAdoptionDTCReducer = createReducer(
  featureFlagHillsPostAdoptionDTCInitialState,
  on(featureFlagsActions.loadFeatureFlagHillsPostAdoptionDTC, (state) => state),
  on(featureFlagsActions.setFeatureFlagHillsPostAdoptionDTC, (state, { featureFlag }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    hillsPostAdoptionDTC: featureFlag
  })),
  on(featureFlagsActions.getFeatureFlagHillsPostAdoptionDTCError, (state, { errorCode, errorMessage }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: false,
    errorCode,
    errorMessage
  })),
  on(featureFlagsActions.resetFeatureFlagHillsPostAdoptionDTC, () => ({
    ..._.cloneDeep(featureFlagHillsPostAdoptionDTCInitialState),
  }))
);

export const featureFlagInsuranceReducer = createReducer(
  featureFlagInsuranceInitialState,
  on(featureFlagsActions.loadFeatureFlagInsurance, (state) => state),
  on(featureFlagsActions.setFeatureFlagInsurance, (state, { featureFlag }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    insurance: featureFlag,
  })),
  on(featureFlagsActions.getFeatureFlagInsuranceError, (state, { errorCode, errorMessage }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: false,
    errorCode,
    errorMessage,
  })),
  on(featureFlagsActions.resetFeatureFlagInsurance, () => ({
    ..._.cloneDeep(featureFlagInsuranceInitialState),
  }))
);
